import red from 'material-ui/colors/red'

export const styles = theme => ({
  actions: {
    float: 'right'
  },
  card: {
    minWidth: 350
  },
  errorMessage: {
    color: red[500],
    fontWeight: 'bold',
    marginTop: 16,
    textAlign: 'center'
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing.unit * 3
  },
  title: {
    color: theme.palette.primary.contrastText,
    marginBottom: 12,
    fontSize: 50,
    fontFamily: "'Monoton', cursive"
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  submit: {
    display: 'none'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/screens/Login.js